import { render } from "./ProductionDocumentsList.vue?vue&type=template&id=24a14163"
import script from "./ProductionDocumentsList.vue?vue&type=script&lang=js"
export * from "./ProductionDocumentsList.vue?vue&type=script&lang=js"

import "./ProductionDocumentsList.vue?vue&type=style&index=0&id=24a14163&lang=css"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__